var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 436.55 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2d3539;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.75,36.13A31.75,31.75,0,1,0,199.5,67.88,31.78,31.78,0,0,0,167.75,36.13Zm0,48.5A16.75,16.75,0,1,1,184.5,67.88,16.77,16.77,0,0,1,167.75,84.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.85,36.13a31.75,31.75,0,1,0,31.76,31.75A31.79,31.79,0,0,0,81.85,36.13Zm0,48.5A16.75,16.75,0,1,1,98.61,67.88,16.78,16.78,0,0,1,81.85,84.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.22,36.13H271a17.11,17.11,0,0,0-17.09,17.09V82.53A17.12,17.12,0,0,0,271,99.63h86.27a17.12,17.12,0,0,0,17.1-17.1V53.22A17.12,17.12,0,0,0,357.22,36.13Zm2.1,46.4a2.1,2.1,0,0,1-2.1,2.1H271a2.1,2.1,0,0,1-2.09-2.1V53.22A2.1,2.1,0,0,1,271,51.13h86.27a2.1,2.1,0,0,1,2.1,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.27,153.64a136.56,136.56,0,0,0-84.17,28.68,7.5,7.5,0,0,0,9.16,11.88,121.71,121.71,0,0,1,75-25.56A122.85,122.85,0,1,1,123,213.93a7.5,7.5,0,0,0-11.63-9.48,138.14,138.14,0,0,0-30.95,87c0,76,61.84,137.86,137.85,137.86s137.86-61.84,137.86-137.86S294.29,153.64,218.27,153.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.55,453.78V57.64A57.71,57.71,0,0,0,378.91,0H57.63A57.7,57.7,0,0,0,0,57.64V454.37A57.69,57.69,0,0,0,57.63,512H378.91a57.68,57.68,0,0,0,57.61-56.78A14.35,14.35,0,0,0,436.55,453.78Zm-15-6.91H359.46a7.5,7.5,0,1,0,0,15h61.43a42.72,42.72,0,0,1-42,35.13H57.63a42.71,42.71,0,0,1-42-35.13h313.8a7.5,7.5,0,0,0,0-15H15V135.76H421.55Zm0-326.11H15V57.64A42.68,42.68,0,0,1,57.63,15H378.91a42.69,42.69,0,0,1,42.64,42.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.27,188.5A103,103,0,0,0,116.35,306.35h0a103,103,0,0,0,203.84,0v0A103,103,0,0,0,218.27,188.5Zm57.84,169.31A88,88,0,0,1,132,308.76l4.63-3.15a23.26,23.26,0,0,1,25.92,0,38.38,38.38,0,0,0,42.79,0,23.3,23.3,0,0,1,25.92,0,38.39,38.39,0,0,0,42.8,0,23.19,23.19,0,0,1,25.91,0l4.63,3.15A88,88,0,0,1,276.11,357.81Zm30.16-65.95-.17-.09a39.08,39.08,0,0,0-13-4.65,37.36,37.36,0,0,0-17.32,1.17,37.93,37.93,0,0,0-10.19,4.92,23.28,23.28,0,0,1-25.92,0,38,38,0,0,0-42.8,0,23.23,23.23,0,0,1-25.91,0,38,38,0,0,0-40.52-1.44l-.16.09v-.37a88,88,0,0,1,176,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/Laundry.9e7cec956f86dd8c214cdf1bcf07144f.svg";
export { ForwardRef as ReactComponent };